import styled from "styled-components";
import FilterNumber from "components/Filter/FilterNumber";
/**
 * Icons
 */
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { useState } from "react";

interface IFooter {
  lastPage: number; //Última Página
  currentPage: number; //Página Atual
  fetchData: (pageNumber: number, perPageNumber: number) => void; // Função para buscar dados
  allPerPage: number; // Número de itens por página
}

export default function Footer({
  lastPage,
  currentPage,
  fetchData,
  allPerPage
}: IFooter) {
  const [perPage, setPerPage] = useState(10);

  const handlePerPageChange = (newPerPage: number) => {
    setPerPage(newPerPage);
    fetchData(1, newPerPage);
  };

  const goToNextPage = () => {
    if (currentPage < lastPage) {
      fetchData(currentPage + 1, perPage); // Chama a API com a próxima página
    }
  };

  const goToPrevPage = () => {
    if (currentPage > 1) {
      fetchData(currentPage - 1, perPage); // Chama a API com a página anterior
    }
  };

  return (
    <Container>
      <ContentLeft>
        <Title>Exibindo por página</Title>
        <FilterNumber
          handlePageChange={handlePerPageChange}
          allFilter={allPerPage}
        />
      </ContentLeft>

      <ContentRight>
        <p>
          {currentPage} de {lastPage}
        </p>
        <ChangePage>
          <Button onClick={goToPrevPage}>
            <FiChevronLeft />
          </Button>
          <Button onClick={goToNextPage}>
            <FiChevronRight />
          </Button>
        </ChangePage>
      </ContentRight>
    </Container>
  );
}

const Container = styled.main`
  display: flex;
  justify-content: space-between;
  height: 5%;
`;

const ContentLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const ContentRight = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const ChangePage = styled.div`
  display: flex;
  gap: 15px;
`;

const Button = styled.button`
  padding: 5px 10px;
  border-radius: 30px;
  display: flex;

  &:hover {
    background-color: ${(props) => props.theme.colors.gray.gray_100};
  }

  svg {
    font-size: 16px;
  }
`;

export const Title = styled.p`
  @media (max-width: 700px) {
    display: none;
  }
`
